;(function () {
	if (!(WC?.idMenu === 175 && !WC?.idCliente)) {
		return
	}

	moveMaps()
})()

function moveMaps() {
	const bodypage = document.querySelector('.body-page')
	const maps = document.querySelector('.cornicemappa')

	bodypage.insertBefore(maps, bodypage.querySelector('.riquadro'))
}
